import { render } from "./PrenatalInfo.vue?vue&type=template&id=f4e5ba8e&scoped=true"
import script from "./PrenatalInfo.vue?vue&type=script&lang=js"
export * from "./PrenatalInfo.vue?vue&type=script&lang=js"

import "./PrenatalInfo.vue?vue&type=style&index=0&id=f4e5ba8e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4e5ba8e"]])

export default __exports__